import React, { FunctionComponent } from 'react'

type StatRowProps = {
	label: React.ReactNode
	value: React.ReactNode
}

const StatRow: FunctionComponent<StatRowProps> = ({ label, value }) => (
	<div className="stat-row">
		<div className="stat-row__label">{label}</div>
		<div className="stat-row__val">{value}</div>
	</div>
)

export default StatRow
